/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HpmsReportsModalAliases {
  HPMS_REPORT_LIST = 'hpms-report-list',
  LAYOUT_MODAL = 'layout-modal',
  PANEL_LIST = 'panel-list',
  PANEL_TITLE = 'panel-title',
  TEXT_TITLE = 'text-title',
}
export { HpmsReportsModalAliases };
